/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL, GET_SITESETTINGS } from "../../constant/constants";
import { LoaderProvider } from "../../context";
import store from "../../dataSlice";
import "../../sass/style.scss";
import AllRoute from "../router";

const App = () => {
  const [siteSetting, setSiteSetting] = useState({});

  useEffect(() => {
    fetch(`${GET_SITESETTINGS}`)
      .then((response) => response.json())
      .then((data) => {
        setSiteSetting(data.general_settings[0]);
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.href = `${BASE_URL}${siteSetting.favicon}`;
    console.log("link favicon", `${BASE_URL}${siteSetting.favicon}`);
  }, [siteSetting.favicon]);

  return (
    <div className="App" id="scrool">
      <HelmetProvider>
        <Helmet>
          <title>
            {siteSetting.title
              ? siteSetting.title
              : "Companigonj Upzilla Somiti Dhaka"}
          </title>
        </Helmet>
        <Provider store={store}>
          {" "}
          <LoaderProvider>
          <Router>
          <AllRoute logo={siteSetting.logo} />{" "}
          </Router>
          </LoaderProvider>
        </Provider>
        <ToastContainer />
      </HelmetProvider>
    </div>
  );
};

export default App;
